module.exports = __webpack_public_path__ + "assets/img/benefit-level-47d692d3.png";